module.exports = __webpack_public_path__ + "img/uploading.4c91d11f.svg";